#import "../../../shared/graphql/fragments/quote-template-fragment.graphql"

query GetQuoteTemplate {
    quoteTemplate {
        ...QuoteTemplateFragment
    }
}
